import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import ReactRouterPropTypes from 'react-router-prop-types';

class Tabs extends PureComponent {
  state = {
    activeTabIndex: 0,
  };

  changeTab = (ev) => {
    const { history } = this.props;
    const {
      currentTarget: { id },
    } = ev;

    this.setState({
      activeTabIndex: id * 1,
    });

    // history.replace('?');
  };

  render() {
    const { config } = this.props;
    const { activeTabIndex } = this.state;

    return (
      <div className="custom-tab">
        <nav>
          <ul className="nav nav-tabs content">
            {config.map((tab, index) => (
              <li className="nav-item" key={index}>
                <button
                  id={index}
                  onClick={this.changeTab}
                  className={`nav-link ${
                    activeTabIndex === index ? 'active' : ''
                  }`}
                  type="button"
                >
                  {tab.title}
                </button>
              </li>
            ))}
          </ul>
        </nav>
        {/* <div className="tab-content">
          {config.map((tab, index) => {
            if (activeTabIndex === index) {
              return (
                <div key={index} className="tab-pane show active">
                  {tab.content}
                </div>
              );
            }
            return null;
          })}
        </div> */}
      </div>
    );
  }
}

Tabs.propTypes = {
  config: PropTypes.arrayOf(PropTypes.shape).isRequired,
  history: ReactRouterPropTypes.history.isRequired,
};

export default withRouter(Tabs);
